export enum AuthRoutes {
  Auth = 'auth',
  Login = 'login',
  Register = 'register',
  ResetPassword = 'reset-password',
  TwoFactorAuth = '2fa',
  EmailConfirmed = 'email-confirmed',
}
